import { Heart, Lightbulb } from "lucide-react";
import { ChecklistStrip } from "../GuideCards";

const solutionPoints = [
    "Explore real-life bullying scenarios",
    "Practice speaking up in a safe environment",
    "Build empathy and emotional awareness",
    "Learn how to support one another",
    "Strengthen confidence and communication skills",
];

export default function SchoolsSolution() {
    return (
        <section className="relative overflow-hidden bg-[#fff8e7] px-6 py-16 lg:px-8">
            {/* Background image placeholder */}
            <div
                className="absolute right-0 top-0 h-full w-full bg-cover bg-center opacity-15"
                style={{
                    backgroundImage: "url('/assets/schools/solution-bg.png')",
                }}
            />

            <div className="relative mx-auto max-w-5xl">
                <div className="grid gap-8 md:grid-cols-[0.9fr_1.1fr] md:items-center">
                    <div className="rounded-[28px] border-[5px] border-black bg-white p-6 shadow-[9px_9px_0_#000]">
                        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full border-[4px] border-black bg-[#ff3366] text-white shadow-[4px_4px_0_#000]">
                            <Lightbulb size={32} strokeWidth={3} />
                        </div>

                        <h2 className="text-3xl font-black uppercase leading-none md:text-4xl">
                            The Solution:
                            <span className="block text-[#16bdf4] drop-shadow-[3px_3px_0_#000]">
                                Call It Out
                            </span>
                        </h2>

                        <p className="mt-5 rounded-[16px] border-[3px] border-black bg-[#f8f4ea] p-4 text-base font-bold leading-7">
                            Through guided, peer-to-peer gameplay, students move from
                            simply knowing bullying is wrong to practicing what they can
                            actually say and do.
                        </p>
                    </div>

                    <ChecklistStrip
                        icon={Heart}
                        title="Through Gameplay, Students..."
                        items={solutionPoints}
                        color="bg-[#22c55e]"
                    />
                </div>

                <div className="mx-auto mt-8 max-w-3xl rotate-[1deg] rounded-[20px] border-[4px] border-black bg-[#ffbc00] p-5 text-center shadow-[7px_7px_0_#000]">
                    <p className="text-2xl font-black uppercase leading-tight">
                        This is where awareness becomes action.
                    </p>
                </div>
            </div>
        </section>
    );
}